/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M15.9652 7.9969C14.9079 7.0652 13.52 6.5 12 6.5c-3.3137 0-6 2.6863-6 6 0 1.7907.7845 3.3982 2.0285 4.4975 1.0536.9309 2.4367 1.4976 3.9516 1.5025H12c3.3137 0 6-2.6863 6-6 0-1.7937-.7871-3.4036-2.0348-4.5031ZM4.537 11.75l.0017-.0168C4.9228 7.9512 8.1167 5 12 5c3.889 0 7.0867 2.96 7.463 6.75h3.787a.75.75 0 0 1 0 1.5h-3.787a.9553.9553 0 0 0-.0017.0168C19.0772 17.0488 15.8833 20 12 20c-3.889 0-7.0867-2.96-7.463-6.75H.75a.75.75 0 0 1 0-1.5h3.787Z"
    clipRule="evenodd"
  />,
  'Commit'
);
